import { configureStore } from "@reduxjs/toolkit";
import { MainUserSlice } from "./slices/UserSlice";
import { WeatherSlice } from "./slices/WeatherSlice";

export const store = configureStore({
    reducer: {
        users: MainUserSlice.reducer,
        weather: WeatherSlice.reducer,
    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch